import { apiRequest } from "@services/apiClient";
import ratingsEndpoints from "@services/ratings/ratingsEndpoints";

function normalizeRatingsFromBody(body) {
  if (Array.isArray(body?.ratings)) return body.ratings;
  if (Array.isArray(body?.items)) return body.items;
  if (Array.isArray(body)) return body;
  return [];
}

function normalizeSingleRatingBody(body) {
  return body?.rating && typeof body.rating === "object" ? body.rating : {};
}

export async function listRatingsRequest(tourId) {
  const response = await apiRequest(ratingsEndpoints.list(tourId));
  return {
    ...response,
    body: normalizeRatingsFromBody(response?.body),
  };
}

export async function createRatingRequest(payload) {
  const response = await apiRequest(ratingsEndpoints.base, {
    method: "POST",
    body: payload,
  });
  return {
    ...response,
    body: normalizeSingleRatingBody(response?.body),
  };
}

export async function updateRatingRequest(payload) {
  const response = await apiRequest(ratingsEndpoints.base, {
    method: "PUT",
    body: payload,
  });
  return {
    ...response,
    body: normalizeSingleRatingBody(response?.body),
  };
}

export async function saveRatingRequest(payload) {
  if (String(payload?.id || "").trim()) {
    return updateRatingRequest(payload);
  }
  return createRatingRequest(payload);
}

export function deleteRatingRequest(id) {
  return apiRequest(ratingsEndpoints.byId(id), {
    method: "DELETE",
  });
}
